@if (defects().length > 0) {
  <span class="defect-ref-chips" role="group" [attr.aria-label]="'defect.ref.groupLabel' | translate">
    @for (d of defects(); track d.id) {
      <a
        class="defect-ref-chips__chip"
        data-testid="defect-chip"
        [class.defect-ref-chips__chip--blocking]="d.blocking"
        [attr.data-blocking]="d.blocking"
        [routerLink]="['/projects', projectId(), 'defects', d.id]"
        [attr.title]="(d.blocking ? 'defect.ref.blockingTitle' : 'defect.ref.title') | translate"
        [attr.aria-label]="(d.blocking ? 'defect.ref.openBlocking' : 'defect.ref.open') | translate: { key: d.key }"
      >
        {{ d.key }}
      </a>
    }
  </span>
}
